import React, {  } from 'react'
import Loading from '../tools/Loading';
import MessageAlert from '../tools/MessageAlert';


const FormAgregar = ({funcion,loading,error, message, value, change, placeholder}) => {
    
    const {name} = value;
    return (
        <form className='form_add'>
            <input 
                type='text' name='name' 
                value={name} onChange={change} 
                placeholder={placeholder}
                className='input_form'
            />
            {
                error
                && <MessageAlert alert='warn' msg={message} />
            }
            {
                loading
                ? <Loading />
                :   <button 
                        type='button' 
                        onClick={() => funcion(name)}
                        className='btn btn_success'
                    >Agregar</button>
            }
        </form>
    )
}

export default FormAgregar
